export * from './lib/components/kundenanlage.component';

// export * from './lib/kundenanlage.shared';
export * from './lib/kundenanlage.routes';
export * from './lib/kundenanlage.providers';
